import axios from "axios";
import { useState } from "react";
import { createContext, useEffect } from "react";
export let cartContext = createContext();

export function CartContextProvider(props) {
  const [cartId, setcartId] = useState(null);
  let [numOfCartItems, setnumOfCartItems] = useState(0);
  const [isCartLoaded, setIsCartLoaded] = useState(false); // Track loading state

  async function getCart() {
    try {
      let token = localStorage.getItem("Auth");
      if (token) {
        const response = await axios.get("https://api.elza2.store/api/v1/cart", {
          headers: { Authorization: token },
        });
        if (response.data.message === "success") {
          setnumOfCartItems(response.data.response.numOfCartItems);
          setcartId(response.data.response.cart._id);
        }
      }
    } catch (error) {
      setnumOfCartItems(0);
      console.log("Error fetching cart data: ", error);
    } finally {
      setIsCartLoaded(true);
    }
  }

  let headers = { Authorization: localStorage.getItem("Auth") };

  async function addToCart(
    x,
    quantity,
    size,
    image,
    note,
    Languages,
    selectedFeatures
  ) {

    let formData = new FormData();

    // Append basic product information
    formData.append("product", x);
    formData.append("quantity", quantity);

    // Append size and userImage (if available)
    if (size) {
      formData.append("size", size);
      formData.append("userImage", image);
    }

    if (note) {
      if (!Array.isArray(note)) {
        note = [note];
      }
      note.forEach((n) => {
        if (Languages) {
          formData.append("userNote[]", `${n} (${Languages.join(", ")})`);
        } else {
          formData.append("userNote[]", n);
        }
      });
    }

    if (selectedFeatures && selectedFeatures.length > 0) {
      selectedFeatures.forEach((feature) => {
        formData.append("features[]", feature);
      });
    }

    // Send the FormData to the server
    return axios
      .post("https://api.elza2.store/api/v1/cart", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: localStorage.getItem("Auth"), // Authorization header
        },
      })
      .then((response) => response)
      .catch((error) => error);
  }

  async function getLoggedUserCart() {
    try {
      const response = await axios.get(`https://api.elza2.store/api/v1/cart`, {
        headers: headers,
      });
      if (response.data.message === "success") {
        setnumOfCartItems(response.data.response.numOfCartItems);
      }

      return response;
    } catch (error) {
      setnumOfCartItems(0);
      console.error("Error fetching logged user cart:", error);
      throw error;
    }
  }

  //Delete item from the cart
  async function removeItem(productId, size = null) {
    try {
      const response = await axios.delete(
        `https://api.elza2.store/api/v1/cart/${productId}/${size}`,
        { headers: headers }
      );
      return response;
    } catch (error) {
      console.error("Failed to remove item:", error);
      throw error;
    }
  }
  //update product count
  async function updateProductCount(
    productId,
    count,
    size = null,
    itemType = "product"
  ) {
    try {
      const response = await axios.put(
        `https://api.elza2.store/api/v1/cart/${productId}/${size}?type=${itemType}`,
        { quantity: count },
        { headers: headers }
      );

      if (response.data.message === "Cart Updated Successfully") {
        setnumOfCartItems(response.data.cart.numOfCartItems); // Adjusted to match backend response
      }
      return response;
    } catch (error) {
      console.error("Failed to update product count:", error);
      throw error;
    }
  }

  // Clear the cart
  async function clearCart(x) {
    return axios
      .delete(`https://api.elza2.store/api/v1/cart`, {
        headers: headers,
      })
      .then((response) => response)
      .catch((error) => error);
  }

  //Online payment
  async function onlinePayment(cartId, shippingAddress) {
    return axios
      .post(
        `https://ecommerce.routemisr.com/api/v1/orders/checkout-session/${cartId}?url=http://localhost:3000`,
        {
          //fe eldatabase fe count hwa heb3at fe el count
          shippingAddress: shippingAddress,
        },
        {
          headers: headers,
        }
      )
      .then((response) => response)
      .catch((error) => error);
  }

  useEffect(() => {
    getCart(); // Fetch cart data on initialization
  }, []);

  return (
    // bn5leha globle 3l project kolo
    <cartContext.Provider
      value={{
        cartId,
        numOfCartItems,
        setnumOfCartItems,
        onlinePayment,
        addToCart,
        getLoggedUserCart,
        removeItem,
        updateProductCount,
        clearCart,
      }}
    >
      {props.children}
    </cartContext.Provider>
  );
}
